<template>
  <!-- Dashboard delle transazioni utente -->
  <div>
    <!-- Modificatore della variabile act-for per richiedere dati di altre aziende -->
    <!-- associate al referente aziendale. Visibile solo se stiamo operando come referente -->
    <SwitcherAziende v-if="!show_as_utente"/>

    <!-- Se stiamo navigando qui come utente torniamo alla home principale -->
    <!-- se invece siamo un referente aziendale torniamo alla home del referente -->
    <PageTagline v-if="show_as_utente" :elements="tagline_elem"/>
    <PageTagline v-else :is_ref_azi_area="true" :elements="tagline_elem"/>

    <!-- Modale per la visualizzazione delle transazioni annullate, richiede il parametro -->
    <!-- row_attributed della datatable per funzionare, per sapere come devono essere     -->
    <!-- categorizzate le transazioni in merito al colore per kind ed in merito alla      -->
    <!-- funzionalità di replay.                                                          -->
    <TransAnnModal v-model="t_ann_show" :row_attributes="datatable.row_attributes"/>

    <!-- Modale per la visualizzazione dello stato dei crediti attivi ( credito -->
    <!-- spendibile e contabile )                                               -->
    <CredStatusModal v-model="cred_modal_show" />

    <!-- CARD CONTENIMENTO GRAFICI -->
    <b-card no-body class="mr-1 ml-1">
      <b-card-header>
        <h5><font-awesome-icon icon="info-circle" size="lg"/> Situazione</h5>
      </b-card-header>
      <b-card-body>
        <b-row class="mt-5 mb-5">
          <b-col cols="12" class="pt-2 pb-2 text-center border rounded">
            <div v-if="show_as_utente">
              <h3>Saldo: <span :style="credito_tot_style">{{credito_totale}}</span> €</h3>
              <h3>di cui ART 51 C.3: <span :style="credito_buoni_style">{{credito_buoni}}</span> €</h3>
            </div>
            <div v-else>
              <!-- Saldo aziendale - visualizza uno spinner fintanto che il dato non è pronto -->
              <h3 v-if="saldo_aziendale===null">Saldo residui utenti: <b-spinner variant="primary" label="loading" class="h6" small></b-spinner></h3>
              <h3 v-else>Saldo residui utenti: <span :style="saldo_aziendale_style">{{saldo_aziendale}}</span> €</h3>
              <!-- Saldo anticipi - visualizza uno spinner fintanto che il dato non è pronto -->
              <h3 v-if="saldo_anticipi===null">Saldo anticipi: <b-spinner variant="primary" label="loading" class="h6" small></b-spinner></h3>
              <h3 v-else>Saldo anticipi: <span :style="saldo_anticipi_style">{{saldo_anticipi}}</span> €</h3>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <!-- GRAFICO DEL SALDO -->
            <h4 class="mb-3 text-center">Stato del credito</h4>
            <BarChart v-if="gs_dati_ok" :chartData="gs_chartdata" class="graph_small"/>
          </b-col>
          <!--<b-col md="6">-->
            <!-- GRAFICO RIPARTIZIONE MOVIMENTI -->
            <!-- 7/11/2024 In seguito a richiesta di Luca viene disabilitato momentamente questo grafico               -->
            <!-- in quando la ripartizione percentuale su base dei movimenti e non su base del credito non viene       -->
            <!-- considerata corretta per la consultazione. Vedremo poi se ripristinarlo in futuro in maniera diversa. -->
            <!--<h4 class="mb-3 text-center">Ripartizione percentuale dei movimenti</h4>-->
            <!--<PieChart v-if="gm_dati_ok" :chartData="gm_chartdata"/>-->
            <!--<p class="font-italic text-secondary text-center"><small>Clicca su un elemento della legenda per escluderlo dalla visualizzazione.</small></p>-->
          <!--</b-col>-->
        </b-row>
      </b-card-body>
    </b-card>

    <!-- CARD DI VISUALIZZAZIONE DEI DOWNLOADS PER IL REFERENTE AZIENDALE -->
    <!-- Visibile per l'appunto solo se si è referenti aziendali -->
    <RefAziDownloads v-if="!show_as_utente"/>

    <!-- CARD DI CONTENIMENTO DELLA TABELLA -->
    <b-card no-body class="mr-1 ml-1 mt-3">
      <b-card-header>
        <h5><font-awesome-icon icon="chart-line" size="lg"/> Storico Movimenti</h5>
      </b-card-header>
      <b-card-body>
        <!-- Form con il filtro per data di inizio e fine, essendo solo selezioni non usiamo b-form -->
        <b-card sub-title="Filtra i movimenti per intervallo di inizio e fine:">
          <b-row>
            <b-col md="3">
              <!-- Filtro data inizio -->
              <b-form-group id="group-date-start"
                label="Data inizio:"
                label-for="date-start">
                <b-form-datepicker
                    id="date-start"
                    v-model="datatable.date_start" class="mb-2"
                    :start-weekday="timepicker_it.start_weekday"
                    v-bind="timepicker_it.labels"
                    @input="filter_by_date"
                    ></b-form-datepicker>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <!-- Filtro data fine -->
              <b-form-group id="group-date-stop"
                label="Data fine:"
                label-for="date-stop">
                <b-form-datepicker
                    id="date-stop"
                    v-model="datatable.date_stop" class="mb-2"
                    :start-weekday="timepicker_it.start_weekday"
                    v-bind="timepicker_it.labels"
                    @input="filter_by_date"
                    ></b-form-datepicker>
              </b-form-group>
            </b-col>
            <b-col>
              <!-- Bottone di reset del filtro per data -->
              <b-button class="ml-2 action_button" variant="primary"
                        :disabled="reset_btn_state"
                        @click="reset_date_filter">Resetta filtro</b-button>
              <!-- Bottone scaricamento dati -->
              <b-button class="ml-2 action_button" variant="primary"
                        :disabled="download_btn_disabled"
                        @click="download_data">
                <!-- Contenuto durante il download ( bottone disabiltiato ) -->
                <span v-if="download_btn_disabled">
                  <b-spinner variant="light" clas="mr-1" small></b-spinner>
                  Attendere, scaricamento in corso...
                </span>
                <!-- Contenuto a riposo ( bottone abilitato ) -->
                <span v-else><b-icon icon="cloud-download" class="mr-1"></b-icon>
                {{download_button_string}}
                </span>
              </b-button>
            </b-col>
          </b-row>
        </b-card>
        <!-- Filtro elementi per stringa e download dei dati -->
        <!-- e per la visualizzazione delle transazioni annullate -->
        <!-- ( solo per utenti semplici e non lato referente ) -->
        <b-row class="mt-3">
          <!-- Input box per filtraggio elementi per stringa -->
          <b-col md="3">
            <b-form-group id="group-filtro-tabella"
              label="Ricerca per termine:"
              label-for="filtro_tabella"
              description="Digita per ricercare all'interno degli elementi della tabella ( non ha effetto sui dati scaricati )">
              <b-form-input
                id="filtro_tabella"
                v-model="datatable.filter">
                </b-form-input>
            </b-form-group>
          </b-col>
          <!-- BOTTONI -->
          <b-col offset-md="4">
            <!-- Bottone visualizzare lo stato dei crediti utente attivi -->
            <!-- Questo pulsante è mostrato si vede solo se siamo utenti e non referenti aziendali -->
            <b-button v-if="show_as_utente" class="ml-md-2 action_button mb-3" style="background:#00a65b;border-color:#00a65b" @click="cred_modal_show = true">
              <!--<b-icon icon="graph-up" class="mr-1"></b-icon>Visualizza lo stato dei crediti-->
              <b-icon icon="graph-up" class="mr-1"></b-icon>Visualizza lo stato dei crediti
            </b-button>
          </b-col>
          <b-col>
            <!-- Bottone per le transazioni annullate -->
            <!-- Questo pulsante è mostrato si vede solo se siamo utenti e non referenti aziendali -->
            <b-button v-if="show_as_utente" class="ml-md-2 action_button mb-3" style="background:#ad0c00;border-color:#ad0c00" @click="t_ann_show = true">
              <b-icon icon="trash" class="mr-1"></b-icon>Recupera acquisti annullati
            </b-button>
          </b-col>
        </b-row>

        <!-- QUI LA TABELLA --->
        <!-- no-provider-sorting e no-provider-filtering evita che per ogni azione
             di sorting o filtraggio venga chiamato il backend, ma venga fatto dalla
             tabella stessa. Non usiamo la proprietà stacked su schermi piccoli prediligendo
             il formato tabellare. -->
        <b-table hover
                 responsive
                 ref="mov_table"
                 v-model="datatable.visible_rows"
                 :items="get_table_items"
                 :no-provider-filtering="true"
                 :no-provider-sorting="true"
                 :fields="datatable.fields"
                 :filter="datatable.filter"
                 :tbody-tr-class="row_class"
                 show-empty>

          <!-- Slot per la prima colonna, sostituisce l'id dell'acquisto con l'icona di font awesone definita per il tipo di acquisto -->
          <template v-slot:cell(id_kind)="data">
            <font-awesome-icon size="lg"
              v-b-tooltip.hover.bottom="datatable.row_attributes[ data.item.id_kind ].tooltip_text"
              :icon="datatable.row_attributes[ data.item.id_kind ].fa_icon"
              :style="datatable.row_attributes[ data.item.id_kind ].fa_icon_style"/>
          </template>

          <!-- Slot per la colonna id_acquisto. Se la tipologia di acquisto ammette la funzionalità di replay, e l'utente -->
          <!-- che sta visualizzando la pagina non è un referente aziendale ma un utente semplice, fa comparire -->
          <!-- affianco all'id acquisto un pulsante per caricare il form del servizio già parzialmente pre compilato -->
          <template v-slot:cell(id_acquisto)="data">
            <div v-if="datatable.row_attributes[ data.item.id_kind ].replay && show_as_utente">
              {{data.value}}
              <b-link class="ml-2 replay-button"
                      :to="{ name : datatable.row_attributes[ data.item.id_kind ].replay_route_name, params: { id_acq_replay: data.value } }">
                <!-- Usiamo il title e non il tooltip boostrap perchè si è visto che quest'ultimo causa saltuarimente -->
                <!-- un errore di Maximum call stack size exceeded nell'hook beforeDestory della DashMovimenti con conseguente -->
                <!-- ritardo nella navigazione verso il form da visualizzare -->
                <font-awesome-icon icon="registered" title="Esegui di nuovo" size='lg'/>
              </b-link>
            </div>
            <div v-else>
              {{data.value}}
            </div>
          </template>

          <!-- Slot per l'oggetto dell'acquisto, se è il referente aziendale l'utilizzatore allora l'oggetto lo stostituiamo   -->
          <!-- con delle stelline per la privacy, in quest'ultimo caso infatti l'oggetto non è neanche restituito dal backend. -->
          <template v-slot:cell(oggetto)="data">
            <p v-if="data.item.oggetto">{{data.item.oggetto}}</p>
            <p v-else>*****</p>
          </template>

          <!-- Slot per le date dei movimenti, le riportiamo nel formato italiano -->
          <template v-slot:cell(created)="data">
            <p>{{ data.value | toitadatetime }}</p>
          </template>

          <!-- Slot per ridefinire il footer dove mettiamo i totali di dare ed avere -->
          <template v-slot:custom-foot>
            <b-tr>
              <b-td></b-td>
              <b-td></b-td>
              <b-td></b-td>
              <b-td></b-td>
              <b-td></b-td>
              <b-td class="font-weight-bold font-italic text-right">Totale:</b-td>
              <!-- Se il totale del dare o dell'avere sono sotto zero li coloriamo in rosso -->
              <b-td v-if="datatable.tot_avere >= 0" class="font-weight-bold font-italic text-center">{{datatable.tot_avere}}</b-td>
              <b-td v-else class="font-weight-bold font-italic text-center" :style="{ color : 'red' }">{{datatable.tot_avere}}</b-td>
              <b-td v-if="datatable.tot_dare >= 0" class="font-weight-bold font-italic text-center">{{datatable.tot_dare}}</b-td>
              <b-td v-else class="font-weight-bold font-italic text-center" :style="{ color : 'red' }">{{datatable.tot_dare}}</b-td>
            </b-tr>
          </template>

          <!-- Spinner che informa del caricamento dati attivato dalla tabella quando viene
               chiamata la funzione che prende i dati get_table_items --->
          <template v-slot:table-busy>
            <div class="text-center my-2">
              <b-spinner class="align-middle mr-2" variant="primary"></b-spinner>
              <strong class="text-primary">Caricamento...</strong>
            </div>
          </template>

          <!-- Slot che visualizza un messaggio quando la tabella non ha elementi, deve essere aggiunta
               la proprietà "show-empty" alla tabella -->
          <template v-slot:empty>
            <p class="text-center"><font-awesome-icon icon="exclamation-circle" size="lg"/>  Nessun elemento presente</p>
          </template>

          <!-- Slot che visualizza un messaggio quando il filtro non restituisce risultati, deve essere aggiunta
               la proprietà "show-empty" alla tabella -->
          <template v-slot:emptyfiltered>
            <p class="text-center"><font-awesome-icon icon="exclamation-circle" size="lg"/>  Nessun elemento trovato</p>
          </template>
        </b-table>
      </b-card-body>
      <div class="mb-2 text-center">{{datatable.visible_rows.length}} elementi visualizzati.</div>
    </b-card>
  </div>
</template>

<script>
import PageTagline from '@/components/PageTagline'
import BarChart from '@/components/graphs/BarChart'
//import PieChart from '@/components/graphs/PieChart'
import TransAnnModal from '@/components/dashmovimenti/TransAnnModal'
import CredStatusModal from '@/components/dashmovimenti/CredStatusModal'
import RefAziDownloads from '@/components/dashmovimenti/RefAziDownloads'
import SwitcherAziende from '@/components/refaziendale/SwitcherAziende.vue'
import { generalLib } from '@/generalLib'
import { apiUrl } from '@/apiUrl'
import axios from 'axios'
import fileDownload from 'js-file-download'

export default {
  name: 'DashMovimenti',
  data () {
    return {
      // Variabili generali
      tagline_elem : [ { text : "Storico Movimenti", link : 'dashmovimenti' } ],

      // Mappa italiana per il timepisker
      timepicker_it : generalLib.timepicker_it,

      // Visualizzazione della modale per le transazioni annullate
      t_ann_show : false,

      // Visualizzazione della modale per lo stato dei crediti attivi
      cred_modal_show : false,

      // Abilitazione/disabilitazione pulsante scaricamento dati
      download_btn_disabled : false,

      // Credito utente e credito buoni per la visualizzazione come saldo quando
      // a visualizzare i dati è l'utente semplice.
      credito_totale : this.$store.state.user.user_credito.totale,
      credito_buoni : this.$store.state.user.user_credito.art51c3,

      // Viene calcolato se l'utente è il referente aziendale al primo caricamento
      // della tabella delle transazioni, quindi se il flag first_time_load è true
      saldo_aziendale : null,

      // Viene valorizzato solo se l'utente è il referente aziendale appena dopo
      // il caricamento della tabella.
      saldo_anticipi: null,

      // TABELLA MOVIMENTI
      // Oggetto con le info per la tabella
      datatable : {

        // Definizione delle colonne per la tabella.
        fields: [
          {
            key: 'id_kind',
            label: 'Tipologia',
            sortable: true,
            tdClass: 'text-center'
          },
          {
            key: 'id_acquisto',
            label : 'Id Acquisto',
            sortable: true
          },
          {
            key : 'stato_acquisto',
            label: 'Stato Richiesta',
            sortable: true
          },
          {
            key : 'oggetto',
            label: 'Oggetto',
            sortable: true
          },
          {
            key : 'soggetto',
            label: 'Soggetto',
            sortable: true
          },
          {
            key : 'created',
            label: 'Data',
            sortable: true
          },
          {
            key : 'AVERE',
            label: 'Entrate',
            // Classe che colora di verde la colonna AVERE
            tdClass: 'avere_column text-center',
            sortable: true
          },
          {
            key : 'DARE',
            label: 'Uscite',
            // Classe che colora di rosso la colonna DARE
            tdClass: 'dare_column text-center',
            sortable: true
          }
        ],

        // Flag che indica se i dati sono in caricamento
        // nella tabella per la prima volta, ci serve per il
        // calcolo del credito totale se l'utilizzatore è
        // il referente aziendale.
        first_time_load : true,

        // Filtro di ricerca
        filter : null,

        // Variabile associata al v-model della tabella,
        // viene popolata con le righe visualizzate
        visible_rows : [],

        // Totale del dare e avere, calcolati al variare delle righe
        // visibili.
        tot_dare : 0,
        tot_avere : 0,

        // Eventuali date di start e stop per il filtro per data
        date_start : null,
        date_stop : null,

        // Attributi delle righe in base al kind dell'acquisto, il quale è il numero
        // che è chiave dell'oggetto, definiscono:
        // - la classe css della riga
        // - il testo del tooltip sull'icona associata al tipo di acquisto
        // - l'icona associata al tipo di acquisto
        // - il colore dell'icona associata all'acquisto
        // - un flag che ci dice se la tipologia di acquisto ammette l'uso della funzionalità di replay o meno.
        // - il nome della route da utilizzare per l'eventuale funzionalità di replay.
        row_attributes : {
          1  :  { row_class : "row_kind_1",  tooltip_text : "Rimborso",                         fa_icon : "university",          fa_icon_style: { color : "rgba(0,166,90,1)"   }, replay: true,  replay_route_name: 'rimb-spese'                  },
          2  :  { row_class : "row_kind_2",  tooltip_text : "Hype",                             fa_icon : "money-bill-alt",      fa_icon_style: { color : "rgba(0,166,90,1)"   }, replay: false, replay_route_name: null                          },
          3  :  { row_class : "row_kind_3",  tooltip_text : "Rimborso interessi",               fa_icon : "university",          fa_icon_style: { color : "rgba(0,166,90,1)"   }, replay: true,  replay_route_name: 'rimb-interessi'              },
          4  :  { row_class : "row_kind_4",  tooltip_text : "Preventivo",                       fa_icon : "file-invoice-dollar", fa_icon_style: { color : "rgba(221,75,57,1)"  }, replay: false, replay_route_name: null                          },
          5  :  { row_class : "row_kind_5",  tooltip_text : "Buono",                            fa_icon : "credit-card",         fa_icon_style: { color : "rgba(243,156,18,1)" }, replay: false, replay_route_name: null                          },
          6  :  { row_class : "row_kind_6",  tooltip_text : "Convenzione",                      fa_icon : "handshake",           fa_icon_style: { color : "rgba(221,75,57,1)"  }, replay: false, replay_route_name: null                          },
          7  :  { row_class : "row_kind_7",  tooltip_text : "Previdenza integrativa",           fa_icon : "briefcase",           fa_icon_style: { color : "rgba(96,92,168,1)"  }, replay: true,  replay_route_name: 'conv-previdenza-integrativa' },
          8  :  { row_class : "row_kind_8",  tooltip_text : "Assistenza sanitaria integrativa", fa_icon : "stethoscope",         fa_icon_style: { color : "rgba(96,92,168,1)"  }, replay: false, replay_route_name: null                          },
          9  :  { row_class : "row_kind_9",  tooltip_text : "Piattapasto",                      fa_icon : "utensils",            fa_icon_style: { color : "rgba(96,92,168,1)"  }, replay: false, replay_route_name: null                          },
          10 :  { row_class : "row_kind_10", tooltip_text : "Trasferimento credito",            fa_icon : "money-bill-alt",      fa_icon_style: { color : "rgba(6,234,89,1)"   }, replay: false, replay_route_name: null                          },
          11 :  { row_class : "row_kind_11", tooltip_text : "Preventivo Art51c3",               fa_icon : "file-invoice-dollar", fa_icon_style: { color : "rgba(219,117,61,1)" }, replay: false, replay_route_name: null                          },
          12 :  { row_class : "row_kind_12", tooltip_text : "Bonus",                            fa_icon : "hand-holding-usd",    fa_icon_style: { color : "rgba(255,157,0,1)"  }, replay: false, replay_route_name: null                          },
          13 :  { row_class : "row_kind_13", tooltip_text : "Rimborso Bollette",                fa_icon : "university",          fa_icon_style: { color : "rgba(0,166,90,1)"   }, replay: true,  replay_route_name: 'rimb-bollette'               },
          14 :  { row_class : "row_kind_14", tooltip_text : "Rimborso Affitto/Mutuo",           fa_icon : "university",          fa_icon_style: { color : "rgba(0,166,90,1)"   }, replay: true,  replay_route_name: 'rimb-aff-mutui'              }
        }
      },

      // GRAFICO SALDO
      gs_backgroundColor: [ 'rgba(0,255,0,0.6)', 'rgba(243,156,18,0.6)' ],
      // Sono questi i dati di partenza da modificare ad ogni aggiornamento.
      // Questa è inoltre la struttura con la quale chartjs vuole i dati in ingresso
      // quindi deve essere replicata identica ad ogni aggiornamento.
      gs_chartdata:  {
        labels: [],
        datasets: [
          {
            backgroundColor: this.gs_backgroundColor,
            data: []
          }
        ]
      },
      // Flag per la prima renderizzazione del grafico. Facciamo in modo che il grafico
      // sia renderizzato nel DOM solo dopo che è avvenuto il primo update dei dati in
      // dare e avere ( in maniera simile a quello che avremmo fatto se i dati erano presi
      // da una api esterna per la quale avrei dovuto aspettare la restituzione del risultato )
      // E' il modo consigliato dalla documentazione ufficiale in quanto nel componente
      // del grafico il rendering è effettuato al mounted del componente.
      gs_dati_ok : false,

      // GRAFICO RIPARTIZIONE MOVIMENTI
      // Grafico con la percentuale dei movimenti per ciacuna tipologia.

      // Colore ed etichetta da dare alle varie tipologie di dati nel grafico.
      // Separo queste dalle da quelle usate per la tabella perchè nel grafico potrei
      // voler usare altre etichette ( tipo quella sul credito ) o non far vedere alcune
      // tipologie di transazione ( tipo le hype ).
      /* **** MOMENTANEAMENTE DISABILITATO **** */
      /**
      gm_kinds : {
          1  :  { label_text : "Rimborso",                         data_color : "rgba(0,166,90,1)"   },
          2  :  { label_text : "Hype",                             data_color : "rgba(0,166,90,1)"   },
          3  :  { label_text : "Rimborso interessi",               data_color : "rgba(0,166,90,1)"   },
          4  :  { label_text : "Preventivo",                       data_color : "rgba(221,75,57,1)"  },
          5  :  { label_text : "Art51c3",                          data_color : "rgba(243,156,18,1)" },
          6  :  { label_text : "Convenzione",                      data_color : "rgba(221,75,57,1)"  },
          7  :  { label_text : "Previdenza integrativa",           data_color : "rgba(96,92,168,1)"  },
          8  :  { label_text : "Assistenza sanitaria integrativa", data_color : "rgba(96,92,168,1)"  },
          9  :  { label_text : "Piattapasto",                      data_color : "rgba(96,92,168,1)"  },
          10 :  { label_text : "Accrediti",                        data_color : "rgba(6,234,89,1)"   },
          11 :  { label_text : "Preventivo Art51c3",               data_color : "rgba(219,117,61,1)" },
          12 :  { label_text : "Bonus",                            data_color : "rgba(255,157,0,1)"  },
          13 :  { label_text : "Rimborso Bollette",                data_color : "rgba(0,166,90,1)"   }
      },

      gm_labels: [],
      gm_backgroundColor: [],
      // Sono questi i dati di partenza da modificare ad ogni aggiornamento.
      // Questa è inoltre la struttura con la quale chartjs vuole i dati in ingresso
      // quindi deve essere replicata identica ad ogni aggiornamento.
      gm_chartdata:  {
        labels: this.gm_labels,
        datasets: [
          {
            label : "Percentuali",
            backgroundColor: this.gm_backgroundColor,
            data: []
          }
        ]
      },
      // Flag per la prima renderizzazione del grafico. Facciamo in modo che il grafico
      // sia renderizzato nel DOM solo dopo che è avvenuto il primo update dei dati in
      // dare e avere ( in maniera simile a quello che avremmo fatto se i dati erano presi
      // da una api esterna per la quale avrei dovuto aspettare la restituzione del risultato )
      // E' il modo consigliato dalla documentazione ufficiale in quanto nel componente
      // del grafico il rendering è effettuato al mounted del componente.
      gm_dati_ok: false,
      ***/
    }
  },
  computed : {
    /**
     * Una semplice computed che trasforma la variabile interna 'entity' in un booleano.
     * Questo è per l'appunto true se stiamo visualizzando le info per l'utente e false
     * se le stiamo visualizzando per l'azienda.
     */
    show_as_utente : function () {
      return this.entity === 'utente' ? true : false;
    },
    /**
     * Calcola lo stato di abilitazione o disabilitazione del pulsante che resetta il filtro
     * per data.
     * Il bottone può essere attivo solo se uno dei due valori non è null.
     */
    reset_btn_state : function () {
      return ( this.datatable.date_start === null && this.datatable.date_stop === null );
    },
    /**
     * Restituisce la stringa del pulsante per lo scaricamento dei dati quando questo non è
     * disabilitato, la quale varia a seconda che sia stato applicto un filtroper data o meno.
     */
    download_button_string : function () {
      if ( this.datatable.date_start === null && this.datatable.date_stop === null ){
        return "Scarica i dati"
      } else {
        return "Scarica i dati filtrati"
      }
    },
    /**
     * Per la visualizzazione del credito totale ( saldo ), se è maggiore di zero
     * è verde se è minore è rosso.
     */
    credito_tot_style : function () {
      return this.credit_color( this.credito_totale );
    },
    /**
     * Per la visualizzazione del credito totale ( saldo ), se è maggiore di zero
     * è verde se è minore è rosso.
     */
    credito_buoni_style : function () {
      return this.credit_color( this.credito_buoni );
    },
    /**
     * Per la visualizzazione del saldo aziendale, se è maggiore di zero
     * è verde se è minore è rosso.
     */
    saldo_aziendale_style : function () {
      return this.credit_color( this.saldo_aziendale );
    },
    /**
     * Per la visualizzazione del saldo anticipi, se è maggiore di zero
     * è verde se è minore è rosso.
     */
    saldo_anticipi_style : function () {
      return this.credit_color( this.saldo_anticipi );
    }
  },
  methods: {
    /**
     * Interroga il backend e torna gli elementi per popolare la tabella.
     *
     * - ctx: è la variabile di contesto che ci serve per interrogare in maniera corretta il backend
     *        questa contiene le chiavi:
     *                   apiUrl: ""      : url da chiamare, nel nostro caso stringa vuota. Perchè chiamiamo l'url nell funzione e non usiamo la prop
     *                   currentPage: 1  : pagina da chiamare ( non ci serve non abbiamo paginazione in questa tabella )
     *                   filter: null    : variabile di filtro, null oppure pari alla stringa che vogliamo filtare ( VIENE FATTO LATO CLIENT - usiamo no-provider-filter )
     *                   perPage: 50     : numero di risultati per pagina ( non ci serve, non abbiamo la paginazione in questa tabella )
     *                   sortBy: ""      : stringa vuota a nome della colonna secondo il quale ordinare i dati ( VIENE FATTO LATO CLIENT - usiamo no-provider-sorting )
     *                   sortDesc: false : ordine di sorting, sempre presente, può essere true o false
     *
     * - callback: funzione di callback da chiamare quando i dati sono pronti.
     */
    get_table_items : function ( ctx, callback ) {

      // Il parametro entity identifica il fatto che dobbiamo prendere i dati per l'utente e non per la sua azienda
      let api_url = apiUrl.pdoppiaapi.storico_transazioni.replace( '@entity', this.entity );

      // Aggiungiamo gli eventuali filtri per data
      let date_filter_params = { params : { } }

      if ( this.datatable.date_start !== null ) {
        date_filter_params.params.date_start = this.datatable.date_start;
      }

      if ( this.datatable.date_stop !== null ) {
        date_filter_params.params.date_stop = this.datatable.date_stop;
      }

      axios.get( api_url, date_filter_params )
      .then( ( response ) => {

        let results = response.data;

        // Se è la prima volta che carichiamo la tabella
        // e l'utilizzatore è il referente aziendale calcoliamo il
        // saldo aziendale
        if ( this.datatable.first_time_load && !this.show_as_utente ) {
          let tot_dare = 0;
          let tot_avere = 0;
          for ( let elem of results ) {
            tot_dare += elem.DARE;
            tot_avere += elem.AVERE;
          }
          this.saldo_aziendale = generalLib.arrotonda_ai_decimali( tot_avere - tot_dare );
          this.datatable.first_time_load = false;
        }

        callback( results );
      })
      .catch( (error) => {
        generalLib.backend_error_message_box( this, error.response.data );
        //console.error( error );
        callback ( [] );
      });
    },
    /**
     * Scarica i dati presentati in tabella ( è esclusa la ricerca per termine che viene )
     * effettuata dal client. Se definiti, sono applicati i filtri per data.
     * Per scaricare file con axios abbiamo usato la libreria js-file-download prendendo spunto
     * da: https://stackoverflow.com/questions/41938718/how-to-download-files-using-axios
     */
    download_data : function  () {

      // Il parametro entity identifica per chi stiamo visualizzando i dati:
      // - "utente": il parametro è quindi 'utente'
      // - "referente aziendale": il parametro varrà allora 'azienda'
      let api_url = apiUrl.pdoppiaapi.storico_transazioni.replace( '@entity', this.entity );

      // Aggiungiamo gli eventuali filtri per data ed il parametro download a true,
      // mandatorio per innescare il download
      let call_params = { params : { download : true }, responseType: 'blob' }

      if ( this.datatable.date_start !== null ) {
        call_params.params.date_start = this.datatable.date_start;
      }

      if ( this.datatable.date_stop !== null ) {
        call_params.params.date_stop = this.datatable.date_stop;
      }

      // Disabilitiamo il pulsante di download che riabilitiamo finita la chiamata
      this.download_btn_disabled = true;

      axios.get( api_url, call_params )
      .then( ( response ) => {
        // Prendiamo il nome dall'header content-disposition
        let nome_file = generalLib.get_nome_file( response );
        // Usiamo js-file-donwload per salvare il file sul client
        fileDownload( response.data, nome_file );
        this.download_btn_disabled = false;
      })
      .catch( (error) => {
        this.download_btn_disabled = false;
        generalLib.backend_error_message_box( this, error.response.data );
      });
    },
    /**
     * Definisce le classi da attribuire ad ogni riga in base al kind del'acquisto.
     * Ogni classe darà poi un colore diverso alla riga ( vedi gli stili definiti nella
     * sezione style ). Viene usata dalla property tbody-tr-class della tabella.
     */
    row_class : function ( item, type ) {
      if ( item == null ) return;
      let row_class = "";
      try {
        row_class =  this.datatable.row_attributes [ item.id_kind ][ 'row_class' ];
      } catch (error) {
        // Se l'item manca lo segnaliamo in console non blocchiamo esecuzione
        console.error( error );
      }
      return row_class;
    },
    /**
     * Quando in uno dei due timepicker viene cambiata la data si forza
     * il refresh della tabella potendo filtrare ora per la data indicata.
     */
    filter_by_date : function () {
      this.$refs.mov_table.refresh();
    },
    /**
     * Resetta il filtro per data e poi invoca il refresh della tabella.
     */
    reset_date_filter : function () {
      this.datatable.date_start = null;
      this.datatable.date_stop = null;
      this.$refs.mov_table.refresh();
    },
    /**
     * Aggiorna il grafico del saldo ricaricando il dataset, in questo modo
     * essendo il grafico reattivo, viene disegnato con i nuovi dati.
     */
    aggiorna_grafico_saldo : function () {

      // Aggiorno le labels ed il dataset mettendo, a seconda dell'utilizzatore,
      // il credito residuo dell'utente od il saldo aziendale.
      let labels = new Array();
      let data = new Array();

      if ( this.show_as_utente ) {
        labels.push( "Saldo: " + this.credito_totale + " €" );
        labels.push( "Art51c3: " + this.credito_buoni + " €" );
        data.push( this.credito_totale );
        data.push( this.credito_buoni );
      } else {
        labels.push( "Saldo residuo utenti: " + this.saldo_aziendale + " €" );
        labels.push( "Saldo anticipi: " + this.saldo_anticipi + " €" );
        data.push( this.saldo_aziendale );
        data.push( this.saldo_anticipi );
      }

      // Per triggerare il rendering del grafico NON basta modificare l'array data,
      // ma bisogna ricreare da zero l'oggetto chartdata, per farlo uso Objects.assign che crea
      // un oggetto completamente nuovo.
      // https://stackoverflow.com/questions/47148755/vue-js-vue-chartjs-chart-not-updating-when-chartdata-replaced-updated-etc
      this.gs_chartdata = Object.assign( {}, {
        labels: labels,
        datasets: [
          {
            backgroundColor: this.gs_backgroundColor,
            data: data
          }
        ]
      });

      // Mettiamo a true il flag di rendering, se è la prima volta che il
      // grafico è visualizzato allora vue procederà a renderizzare la sua
      // parte di DOM solo ora che il dataset è stato aggiornato.
      this.gs_dati_ok = true;
    },
    /**
     * Aggiorna il grafico dei movimenti calcolando il numero di movimenti per
     * ciscun tipo e la percentuale relativa al totale.
     * Utilizza la variabile delle righe visibili in tabella ( visible_rows ) per
     * effettuare i calcoli sui dati effettivamente visualizzati.
     */
    /*aggiorna_grafico_movimenti : function () {

      // Il totale dei movimenti
      let mov_tot = this.datatable.visible_rows.length;

      // Resetto le vecchie label ed i vecchi colori, preparo anche la nuova
      // array per il dataset
      this.gm_labels = new Array();
      this.gm_backgroundColor = new Array();
      let new_dataset = new Array();

      for ( let kind in this.gm_kinds ) {
        // per ogni tipologia che voglio graficare raccolgo le transazioni di quel tipo in un'array
        let data_by_kind = this.datatable.visible_rows.filter( function ( value ) {
                              return value.id_kind == kind;
                          });

        // Dato l'array dei dati di quel tipo:

        // Calcolo la percentuale di quel tipo di movimenti rispetto al totale con la quale
        // disegnerò il grafico
        let num_movimenti = data_by_kind.length;
        let percentuale = generalLib.arrotonda_ai_decimali( ( num_movimenti / mov_tot ) * 100 );

        // Calcolo importo totale dedicato a quei movimenti
        let tot_dare = data_by_kind.reduce( function ( tot, value ) { return tot + value.DARE }, 0);
        let tot_avere = data_by_kind.reduce( function ( tot, value ) { return tot + value.AVERE }, 0);
        let tot_euro = generalLib.arrotonda_ai_decimali( Math.abs( tot_dare - tot_avere ) );
        //let tot_euro = Math.abs( tot_dare - tot_avere );

        // Colore da dare ai movimenti
        let data_color = this.gm_kinds[ kind ].data_color;

        // Nome movimenti
        let label_text = this.gm_kinds[ kind ].label_text;

        // Posso ora costruire la label
        let graph_label = percentuale + '% ' + label_text + ' ' + tot_euro + ' € (' + num_movimenti + ')';

        // Popolo gli elementi per costruire il dataset solo se il numero di movimenti associati è maggiore di zero
        if ( num_movimenti > 0 )  {
          this.gm_labels.push( graph_label );
          this.gm_backgroundColor.push( data_color );
          new_dataset.push( percentuale );
        }
      }

      // Per triggerare il rendering del grafico NON basta modificare l'array data,
      // ma bisogna ricreare da zero l'oggetto chartdata, per farlo uso Objects.assign che crea
      // un oggetto completamente nuovo.
      // https://stackoverflow.com/questions/47148755/vue-js-vue-chartjs-chart-not-updating-when-chartdata-replaced-updated-etc
      this.gm_chartdata = Object.assign( {}, {
        labels: this.gm_labels,
        datasets: [
          {
            label : "Percentuali",
            backgroundColor: this.gm_backgroundColor,
            data: new_dataset
          }
        ]
      });

      // Mettiamo a true il flag di rendering, se è la prima volta che il
      // grafico è visualizzato allora vue procederà a renderizzare la sua
      // parte di DOM solo ora che il dataset è stato aggiornato.
      this.gm_dati_ok = true;

    },*/
    /**
     * Per la visualizzazione del saldo, usata nelle relative computed properties
     * credito_tot_style e credito_buoni_style.
     * Torna un oggetto che colora di verde o rosso il credito a disposizione a seconda
     * che il valore passato sia maggiore o minore a zero.
     */
    credit_color : function ( value ) {
      if ( value > 0 ) {
        return { color : '#76e024' };
      } else {
        return { color : '#f50000' };
      }
    }
  },
  watch : {
    /**
     * Al variare delle righe visibili nella tabella andiamo a ricalcolare
     * il totale del dare e avere mostrato nel footer.
     */
    'datatable.visible_rows' : function ( val ) {
      //if ( this.datatable.visible_rows.length === 0 ) return;
      this.datatable.tot_dare = this.datatable.visible_rows.reduce (
                                      ( accumulator, item ) => { return accumulator + item.DARE },
                                      0 );
      this.datatable.tot_dare = generalLib.arrotonda_ai_decimali( this.datatable.tot_dare );

      this.datatable.tot_avere = this.datatable.visible_rows.reduce (
                                      ( accumulator, item ) => { return accumulator + item.AVERE },
                                      0 );
      this.datatable.tot_avere = generalLib.arrotonda_ai_decimali( this.datatable.tot_avere );

      // Facciamo anche il refresh del contenuto dei grafici.
      // Dal 9 Febbraio 2024 in particolare il grafico del saldo non dovrebbe
      // essere riaggiornato ogni volta perchè non dipende più dati dati della tabella.
      // Ad ogni modo questo meccanismo di refresh si rende comunque utile per disegnarlo
      // dopo che la tabella dei dati è stata popolata, anche se inefficente quindi lo
      // conserviamo.
      this.aggiorna_grafico_saldo();
      //this.aggiorna_grafico_movimenti(); --> DISABILITATO IN DATA 7/11/2024, vedi commenti nel codice HTML

    }
  },
  /**
   * Se stiamo visualizzando i dati per il referente aziendale, in fase di caricamento
   * va a prendere il dato del saldo anticipi.
   * Se invece non sstiamo operando come referente non dobbiamo fare nulla.
   */
  created : function () {

    if ( this.show_as_utente ) return;

    // Stiamo operando come referente, prendo il dato del saldo anticipi
    axios.get( apiUrl.welfareapi.get_status_conto_anticipi )
    .then( ( response ) => {
        this.saldo_anticipi = response.data.saldo_anticipi;
    })
    .catch( ( error ) => {
      generalLib.backend_error_message_box( this, error.response.data );
    });
  },
  props : {
    /**
     * Entità per la quale andiamo a visualizzare i dati.
     * Di default è 'utente' cioè l'utente correntemente loggato, andiamo
     * cioè a visualizzare la sua dashboard.
     * Il alternativa può essere 'azienda', cioè vengono visualizzati i dati
     * dell'azienda del quale l'utente fa parte, quando è cioè un referente aziendale.
     */
    entity: {
      type: String,
      default : 'utente',
      validator: function (value) {
        // Solleviamo un errore di validazione se non diamo ne 'utente'
        // ne 'azienda' come valore.
        return [ 'utente', 'azienda' ].indexOf(value) !== -1
      }
    }
  },
  components : {
    PageTagline,
    BarChart,
    //PieChart,
    TransAnnModal,
    CredStatusModal,
    SwitcherAziende,
    RefAziDownloads
  }
}
</script>

<style scoped>
/* Allineamento del bottone del reset e scaricamento dati*/
.action_button {
  margin-top: 2em;
}

/* Bottoni di replay degli acquisti */
.replay-button {
  color: #ff6a00;
}
.replay-button:hover {
  color: #ffa600;
}

/* Colore della colonna DARE */
.table-responsive :deep( .dare_column ) {
  background : rgb(255,0,0,0.15);
}

/* Colore della colonna AVERE */
.table-responsive :deep( .avere_column ) {
  background : rgb(0,255,0,0.15);
}

/* Colore delle righe in base alla classe
   css assegnata per il kind di acquisto */
.table-responsive :deep( .row_kind_1 ) {
  background : rgba(0,166,90,0.1);
}
.table-responsive :deep( .row_kind_1:hover ) {
  background : rgba(0,166,90,0.2);
}

.table-responsive :deep( .row_kind_2 ) {
  background : rgba(0,166,90,0.1);
}
.table-responsive :deep( .row_kind_2:hover ) {
  background : rgba(0,166,90,0.2);
}

.table-responsive :deep( .row_kind_3 ) {
 background : rgba(0,166,90,0.1);
}
.table-responsive :deep( .row_kind_3:hover ) {
 background : rgba(0,166,90,0.2);
}

.table-responsive :deep( .row_kind_4 ) {
 background : rgba(221,75,57,0.1);
}
.table-responsive :deep( .row_kind_4:hover ) {
 background : rgba(221,75,57,0.2);
}

.table-responsive :deep( .row_kind_5 ) {
 background : rgba(243,256,18,0.1);
}
.table-responsive :deep( .row_kind_5:hover ) {
 background : rgba(243,256,18,0.2);
}

.table-responsive :deep( .row_kind_6 ) {
 background : rgba(221,75,57,0.1);
}
.table-responsive :deep( .row_kind_6:hover ) {
 background : rgba(221,75,57,0.2);
}

.table-responsive :deep( .row_kind_7 ) {
 background : rgba(96,92,168,0.1);
}
.table-responsive :deep( .row_kind_7:hover ) {
 background : rgba(96,92,168,0.2);
}

.table-responsive :deep( .row_kind_8 ) {
 background : rgba(96,92,90,0.1);
}
.table-responsive :deep( .row_kind_8:hover ) {
 background : rgba(96,92,90,0.2);
}

.table-responsive :deep( .row_kind_9 ) {
 background : rgba(96,92,168,0.1);
}
.table-responsive :deep( .row_kind_9:hover ) {
 background : rgba(96,92,168,0.2);
}

.table-responsive :deep( .row_kind_10 ) {
 background : rgba(6,234,89,0.1);
}
.table-responsive :deep( .row_kind_10:hover ) {
 background : rgba(6,234,89,0.2);
}

.table-responsive :deep( .row_kind_11 ) {
 background : rgba(219,117,61,0.1);
}
.table-responsive :deep( .row_kind_11:hover ) {
 background : rgba(219,117,61,0.2);
}

.table-responsive :deep( .row_kind_12 ) {
 background : rgba(255,187,28,0.1);
}
.table-responsive :deep( .row_kind_12:hover ) {
 background : rgba(255,187,28,0.2);
}

.table-responsive :deep( .row_kind_13 ) {
  background : rgba(0,166,90,0.1);
}
.table-responsive :deep( .row_kind_13:hover ) {
  background : rgba(0,166,90,0.2);
}

.table-responsive :deep( .row_kind_14 ) {
  background : rgba(0,166,90,0.1);
}
.table-responsive :deep( .row_kind_14:hover ) {
  background : rgba(0,166,90,0.2);
}

.graph_small {
    max-width: 500px;
    margin:  0px auto;
}
</style>